module.exports = __webpack_public_path__ + "static/media/Methodology_sideview.2690c579.png";